<template>
  <div class="flex-container">
    <PageTop :title="`Sepette İndirim Kampanya Teklifleri: ${ campaignName }`" />
    <div class="main-area">
      <div class="template-manager">
        <TemplateManager
          :action="action"
          :index="index"
          v-for="(action, index) in joinCampaignActions"
          v-bind:key="index"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import PageTop from "@/components/Page/PageTop.vue";
import TemplateManager from "@/components/TemplateManager/TemplateManager";
import { sendSelectFileEvent, sendSelectProductEvent } from "@/utils/ga4/helper";
import { getCampaignDetail } from './services/umbrellaCampaignService';

const props = defineProps({
  campaignId: {
    type: String,
    default: null,
  },
});

const route = useRoute();
const router = useRouter();
const campaignName = ref('');

const campaignId = computed(() => props.campaignId || route.params.campaignId);

const loadCampaignNameFromStorage = () => {
  const storedCampaignName = sessionStorage.getItem('campaignName');
  if (storedCampaignName) {
    campaignName.value = storedCampaignName;
    sessionStorage.removeItem('campaignName');
  }
};

const fetchCampaignName = async () => {
  if (!campaignId.value) {
    campaignName.value = '';
    return;
  }

  try {
    const data = await getCampaignDetail(campaignId.value);
    campaignName.value = data?.name || campaignName.value || '';
  } catch (error) {
    console.error('Error fetching campaign name:', error);
  }
};

const joinCampaignActions = computed(() => {
  return [
    {
      type: "LIST",
      title: "Listeden Ürün Seç",
      description: "Kampanyaya eklemek istediğiniz ürünleri <br> <span style='color: $colorN80; font-size: 13px; font-weight: 700; line-height: 18px; letter-spacing: -0.05px;'>mağazanızın ürün listesinden</span> seçin. ",
      icon: "create-single@2x.svg",
      buttonText: "Ürün Seç",
      ctaAction: () => {
        const targetRoute = {
          name: 'AddProductsToCampaign',
          params: { campaignId: campaignId.value }
        };

        sendSelectProductEvent({
          link_url: router.resolve(targetRoute)?.href ?? '',
          button_name: "Kampanyaya Ekle",
        });

        router.push({
          ...targetRoute,
        });
      },
      errors: {},
    },
    {
      type: "BULK",
      title: "Toplu Ürün Seç",
      description: "Kampanyaya katılım için toplu ürün seçimi yapmak istiyorsanız, aşağıdaki <span style='color: $colorN80; font-size: 13px; font-weight: 700; line-height: 18px; letter-spacing: -0.05px;'>Excel şablonunu</span> bilgisayarınıza indirip doldurun ve tekrar geri yükleyin.",
      icon: "bulk-upload@2x.png",
      buttonText: "Dosya Seç",
      info: "Dosya <span>.xls formatında</span> ve <span>en fazla 15 MB</span> boyutunda olmalıdır.",
      ctaAction: () => {
        sendSelectFileEvent({
          button_name: "Dosya Seç",
          button_type: "Select File",
          page_type: "Campaign Detail",
        });

        if (!campaignId.value) return;
        router.push({
          name: 'JoinCampaignBulk',
          params: { campaignId: campaignId.value }
        });
      },
      errors: {},
    },
  ];
});

onMounted(async () => {
  loadCampaignNameFromStorage();
  await fetchCampaignName();
});

watch(
  campaignId,
  async () => {
    await fetchCampaignName();
  },
);
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/utilities.scss";

.flex-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  margin-bottom: 24px;

  .main-area {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: $colorN00;
    padding-bottom: 24px;
    border-radius: 8px;
  }

  .template-manager {
    display: flex;
    gap: 24px;
    padding: 40px 24px 16px 24px;

    :deep(.action-description) {
      width: 576px;
      max-width: 100%;
    }
  }
}
</style>
